import { render, staticRenderFns } from "./ItemConsultaProcessada.vue?vue&type=template&id=0a2aeece&scoped=true&lang=pug"
import script from "./ItemConsultaProcessada.vue?vue&type=script&lang=js"
export * from "./ItemConsultaProcessada.vue?vue&type=script&lang=js"
import style0 from "./ItemConsultaProcessada.vue?vue&type=style&index=0&id=0a2aeece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2aeece",
  null
  
)

export default component.exports